import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{staticClass:"main"},[_c(VCol,{staticClass:"text-center grey--text",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("ARSconnect - "+_vm._s(_vm.windowSize)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }